/* eslint-disable @typescript-eslint/no-explicit-any */ // TODO: Remove this disable and fix all any types in this file
import { useDataDisplayConfigQuery } from "@/shared/services/graphql/generated/consumer-graph-types";
import { PropertyItem } from "@/shared/components/views/property-item.model";
import { computed, Ref } from "vue";
import {
    getDataDisplayFields,
    getDataDisplayPropertyItems,
    getDatafieldsFragmentsFromConfig,
    getNodeDataFragments,
    getPriorityDataDisplayFields,
} from "./data-display.helper";
import { DataDisplayConfigId, DataDisplayEntry, DataDisplayField, DatafieldFragments } from "./data-display.model";
import { useLanguageStore } from "@/shared/store/language-store.ts";

export type Translation = (key: string, ...args: any[]) => string;

/** Maps a raw GraphQL node to the property items of a data display config. */
export type GetDataDisplayPropertiesByConfig = (graphqlResultObject: unknown) => PropertyItem[];

export interface DataDisplayResult {
    datafieldsFragment: DatafieldFragments;
    nodeFieldsDataFragment: Record<string, string>;
    dataDisplayFields: DataDisplayField[];
}

export function useDataDisplayConfig(id: DataDisplayConfigId, t: Translation, enabled?: Ref<boolean>) {
    const languageStore = useLanguageStore();

    const dataDisplayConfigVariables = computed(() => {
        return {
            dataDisplayConfigId: id,
            acceptedLanguages: languageStore.dataQueryLanguages,
            length: 200,
        };
    });

    const { result, error, loading } = useDataDisplayConfigQuery(dataDisplayConfigVariables, {
        fetchPolicy: "cache-first",
        enabled: enabled ?? true,
    });

    const dataDisplayFields = computed(() => getDataDisplayFields(result.value, t));

    const returnResult = computed((): DataDisplayResult | undefined => {
        return result.value
            ? {
                  datafieldsFragment: getDatafieldsFragmentsFromConfig(result.value),
                  nodeFieldsDataFragment: getNodeDataFragments(result.value),
                  dataDisplayFields: dataDisplayFields.value,
              }
            : undefined;
    });

    const entries = computed(() => {
        return result.value?.dataDisplayConfig?.entries?.map((x) => {
            const value: DataDisplayEntry = {
                referencedId: x.referencedId,
                fieldType: x.fieldType,
            };

            return value;
        });
    });

    /**
     * Returns an Array of PropertyItem for a graphql-Result by the displayConfig
     */
    const getDataDisplayPropertiesByConfig: GetDataDisplayPropertiesByConfig = (graphqlResultObject) =>
        getDataDisplayPropertyItems(dataDisplayFields.value, graphqlResultObject);

    const priorityDataDisplayFields = computed(() => {
        return getPriorityDataDisplayFields(result.value, t);
    });

    return {
        entries,
        result: returnResult,
        error,
        loading,
        getDataDisplayPropertiesByConfig,
        priorityDataDisplayFields,
    };
}
